import Trix from "trix";

const startTrix = () => {
  Trix.start();
};

document.addEventListener("trix-before-initialize", () => {
  startTrix();
});
